// extracted by mini-css-extract-plugin
var _1 = "whG4H";
var _2 = "nH3wy";
var _3 = "UHb_x";
var _4 = "GkgAG";
var _5 = "qsInr";
var _6 = "gk4gH";
export { _1 as "button", _2 as "is-processing", _3 as "level-destructive", _4 as "level-primary", _5 as "level-secondary", _6 as "spinner" }
